
  import { Vue, Component } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  import { ICounters } from '@/interfaces/search';
  import plural from '@/filters/plural-form';
  import number from '@/filters/format-number';

  const searchStore = namespace('search');

  @Component({
    filters: {
      plural,
      number,
    },
  })
  export default class SearchHeader extends Vue {
    @searchStore.State generalCounters!: ICounters;
  }
